import { render } from "./IndexReview.vue?vue&type=template&id=14b7bb34"
import script from "./IndexReview.vue?vue&type=script&lang=js"
export * from "./IndexReview.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__